












import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';
import deepmerge from 'deepmerge';
import ResizeObserver from 'resize-observer-polyfill';

export default Vue.extend({
  props: ['series', 'labels', 'colors', 'showPercentOnTotal'],
  components: {
    apexchart: VueApexCharts,
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.$refs.donutChart as HTMLDivElement);

    if (this.showPercentOnTotal) {
      this.chartOptions = deepmerge(this.chartOptions, {
        plotOptions: {
          pie: {
            donut: {
              labels: {
                total: {
                  label: '준수율',
                  formatter: function (w: any) {
                    let goodPercentage = 0;
                    for (
                      let idx = 0;
                      idx < w.globals.seriesTotals.length;
                      idx++
                    ) {
                      if (
                        w.globals.seriesNames[idx] !== '미준수' &&
                        w.globals.seriesNames[idx] !== '손상'
                      )
                        goodPercentage += parseFloat(
                          w.globals.seriesPercent[idx],
                        );
                    }
                    return goodPercentage.toFixed(2) + '%';
                  },
                },
              },
            },
          },
        },
      });
    }
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
  computed: {
    computedChartWidth(): string {
      return this.chartWidth + 'px';
    },
  },
  watch: {
    labels: function (labels) {
      this.chartOptions = {
        ...this.chartOptions,
        labels: labels,
      };
    },
    colors: function (colors) {
      this.chartOptions = {
        ...this.chartOptions,
        colors: colors,
      };
    },
  },
  data(): {
    chartOptions: ApexOptions;
    chartWidth: number;
    resizeObserver: ResizeObserver | null;
  } {
    return {
      resizeObserver: null,
      chartWidth: 100,
      chartOptions: {
        labels: this.labels,
        colors: this.colors,
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: '50%',
              labels: {
                show: true,
                total: {
                  show: true,
                  color: '#000000',
                },
              },
            },
          },
        },
        legend: {
          position: 'bottom',
          fontSize: '12px',
          inverseOrder: true,
        },
      },
    };
  },
  methods: {
    onResize() {
      const divElement = this.$refs.donutChart as HTMLDivElement;

      if (divElement.clientHeight * 1.2 < divElement.clientWidth) {
        this.chartWidth = divElement.clientHeight * 1.2;
      } else {
        this.chartWidth = divElement.clientWidth;
      }
    },
  },
});
